"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseExpressionEvaluator = void 0;
const Helpers_1 = require("../../functions/Helpers");
const Err = require("../../util/Errors");
class BaseExpressionEvaluator {
    constructor(termTransformer) {
        this.termTransformer = termTransformer;
    }
    term(expr, mapping) {
        return expr;
    }
    variable(expr, mapping) {
        const term = mapping.get((0, Helpers_1.expressionToVar)(expr));
        if (!term) {
            throw new Err.UnboundVariableError(expr.name, mapping);
        }
        return this.termTransformer.transformRDFTermUnsafe(term);
    }
}
exports.BaseExpressionEvaluator = BaseExpressionEvaluator;
//# sourceMappingURL=BaseExpressionEvaluator.js.map